import { Controller } from "@hotwired/stimulus";

// The shell loaded the exchange by hand (webView.load), and a load is no
// Navigator visit; this one is: /in is replace_root, so the stale signed-out
// root goes (docs/DOORS.md § After the door: /in). No parameter: /in takes none.
export default class extends Controller {
  connect() {
    window.Turbo.visit("/in", { action: "replace" });
  }
}
